import React, { useEffect, useState, useRef } from "react";
import './Libroverde2026.css';
import { useTranslation } from 'react-i18next';
import YoutubeLite from "../../components/YoutubeLite/YoutubeLite";


const Libroverde2026 = () => {
    const [t, i18n] = useTranslation("global");
    const [t2] = useTranslation("home");
    const [t3] = useTranslation("detail_blog");
    const [t4] = useTranslation("biblioteca");
    const [t5] = useTranslation("libroAzul");
    const [t6] = useTranslation("librVerd");

    const [im] = useTranslation("libroBitcoin");
    const bannerImageBlanco =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_4.png"
            : "/assets/img2026/book_cover_4_en.png";
    const bannerImageBitcoin =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_1.png"
            : "/assets/img2026/bitcoin_englightment.png";


    return (
        <>
            <div class="_nghost-ng-c4013722087">
                <article aria-labelledby="book-detail-title" class="book-detail-page">
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c4098101840"><a
                        class="book-detail-page__back-link"
                        href={"/" + i18n.language + "/biblioteca"}>{t("general.back-library")}</a>
                        <div class="book-detail-page__cover"><img
                            src="/assets/img2026/book_details_verde.png"
                            alt="Portada del libro Ideas que transforman negocios para cambiar al mundo" loading="eager"
                            fetchpriority="high" /></div>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3469483597">
                        <section class="book-detail-page__intro">
                            <h1 id="book-detail-title">{t2("2026.libro3")}</h1>
                        </section>
                    </div>

                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3568423662">
                        <section class="book-detail-page__content book-detail-page__content-noborder">
                            <blockquote class="book-detail-page__content-quote">
                                <p class="book-detail-page__content-quote-text">{t6("2026.frase")}</p><cite
                                    class="book-detail-page__content-quote-author">– Ricardo Salinas</cite>
                            </blockquote>
                        </section>
                    </div>

                    
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2131526924">
                        <section class="book-detail-page__content book-detail-page__content-noborder">
                            <p class="book-detail-page__lead">{t6("2026.texto")}</p>
                            <p class="book-detail-page__content-body">{t6("2026.texto2")} </p>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c411527492">
                        <section aria-labelledby="book-detail-feature-title"
                            class="book-detail-feature">
                            <article class="book-detail-feature__media">
                                <video controls class="book-detail-feature__image" poster="/assets/img2026/portada-vid-lib-verde.jpg">
                                    <source src="https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/IDEAS-lanzamiento-720p.mp4" type="video/mp4" />
                                </video>
                            </article>
                            <div class="book-detail-feature__copy">
                                <h2 id="book-detail-feature-title" class="book-detail-feature__title">{t6("2026.subtitulo")}</h2>
                                <p>{t6("2026.desc")}</p>
                                <a target="_blank" class="book-detail-feature__cta boton-compra-only-desk"
                                    href="https://www.amazon.com.mx/dp/6079900696/ref=redir_mobile_desktop/135-4069732-7734861?_encoding=UTF8&qid=&ref_=tmm_pap_swatch_0&sr=">{t5("header.buy")}</a>
                            </div>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2882487804">
                        <section aria-label="Videos del libro" class="book-detail-video-gallery">
                            <article class="book-detail-video-gallery__card">
                                <YoutubeLite videoId="lkCOG_KN3J0" quality="hq" />
                            </article>
                            <article class="book-detail-video-gallery__card">
                                <YoutubeLite videoId="J8_6RIyl4W8" />
                            </article>
                        </section>
                    </div>

                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3568423662">
                        <section class="book-detail-page__content">
                            <blockquote class="book-detail-page__content-quote">
                                <p class="book-detail-page__content-quote-text">{t5("reason.quote-reason-v")}</p><cite
                                    class="book-detail-page__content-quote-author">– Ricardo Salinas</cite>
                            </blockquote>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2882487804">
                        <section aria-label="Videos del libro" class="book-detail-video-gallery">
                            <article class="book-detail-video-gallery__card">
                                <YoutubeLite videoId="XVRZh9ym2Do" />
                            </article>
                            <article class="book-detail-video-gallery__card">
                                <YoutubeLite videoId="6hYPvGH2a3M" />

                            </article>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3500518879">
                        <section id="buy-section" aria-labelledby="book-stores-title"
                            class="book-detail-page__stores">
                            <h2 id="book-stores-title">{t5("libraries.donde")}</h2>
                            <div class="store-row">
                                <h3>{t5("libraries.available-inprestigious")}</h3>
                                <div class="store-row__logos">
                                    <a target="_blank" rel="noreferrer" href="https://www.gandhi.com.mx/ideas-que-transforman-sociedades-para-cambiar-al-mundo" aria-label="Ir a Gandhi">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_gandhi.png"
                                            alt="Gandhi" />
                                    </a>
                                    {/* 
                                    <a target="_blank" rel="noreferrer" href="https://www.elsotano.com/libro-ideas-que-transforman-sociedades-para-cambiar-al-mundo-10632778" aria-label="Ir a Gandhi">
                                        <img
                                            loading="lazy" src="/assets/img2026/El_Sotano_Logo.png"
                                            alt="El_Sotano" />
                                    </a>*/}

                                    <img
                                        loading="lazy" src="/assets/img2026/logo_porrua.png" alt="Porrúa" />


                                    {/* <img loading="lazy"
                                        src="/assets/img2026/logo_sandborns.png" alt="Sanborns" />*/}


                                </div>
                            </div>
                            <div class="store-row">
                                <h3>{t5("libraries.available-as-audio")}</h3>
                                <div class="store-row__logos">
                                    <a
                                        target="_blank" rel="noreferrer" href="https://open.spotify.com/show/4J2DorWHvWqzL0zelMScOy"
                                        aria-label="Ir a Audible">
                                        <img loading="lazy"
                                            src="/assets/img2026/Spotify_logo.png" alt="Audible" />
                                    </a>
                                </div>
                            </div>
                            <div class="store-row">
                                <h3>{t5("libraries.available-as-eBook")}</h3>
                                <div class="store-row__logos">
                                    <a
                                        target="_blank" rel="noreferrer" href="https://www.amazon.com.mx/Ideas-transforman-sociedades-cambiar-mundo-ebook/dp/B0BCBW47SP/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=1WUBHFIK1P31H&dib=eyJ2IjoiMSJ9.G7ZX7qf7vuxH5HcBV5A8UaOFSdhKOW_0RENKtBmz0wcHFapzKxapFGLheXvdLsZn.ic4rZvAMtu-wEJ7Z3M2nqwHwg55llnuSCBCTs7hK9zg&dib_tag=se&keywords=Ideas+que+transforman+sociedades+para+cambiar+al+mundo&qid=1778536154&s=books&sprefix=ideas+que+transforman+sociedades+para+cambiar+al+mundo%2Cstripbooks%2C193&sr=1-1"
                                        aria-label="Ir a Amazon"><img loading="lazy"
                                            src="/assets/img2026/logo_amazon.png" alt="Amazon" />
                                    </a>
                                    <a
                                        target="_blank" rel="noreferrer"
                                        href="https://play.google.com/store/books/details?id=Op-aEAAAQBAJ&pli=1" aria-label="Ir a Google Play">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_google_play.png"
                                            alt="Google Play" />
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="_nghost-ng-c3151073329 fragmento-lib">
                        <section aria-label="Suscripción al boletín" class="blog-newsletter-cta">
                            <div class="blog-newsletter-cta__container">
                                <p class="blog-newsletter-cta__message"><span
                                    class="blog-newsletter-cta__message-desktop">{t("general.lib3")}</span><span
                                        class="blog-newsletter-cta__message-mobile">{t("general.lib3")}</span></p>
                                <a href="https://www.ricardosalinas.com/Content/assets/documents/fragmento-libro-sociedades.pdf" target="_blank" download="fragmento-libro-sociedades.pdf" rel="noreferrer">
                                <button
                                    type="button" class="blog-newsletter-cta__button"><span
                                        class="blog-newsletter-cta__button-desktop">{t("general.libbtn")}</span><span
                                            class="blog-newsletter-cta__button-mobile">{t("general.libbtn2")}</span></button></a>

                    </div>
                </section>
            </div>
            <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3138913358">
                <section aria-labelledby="book-collection-title"
                    class="book-detail-page__collection">
                    <h2 id="book-collection-title" class="book-detail-page__collection-title">
                        {t5("aslo.aslo")}</h2>
                    <div class="book-collection-list">
                        <article class="book-collection-card"><img
                            loading="lazy" class="book-collection-card__image" src="/assets/img2026/book_cover_1.png"
                            alt="Portada del libro Ideas que transforman sociedades para cambiar al mundo" />
                            <div class="book-collection-card__copy">
                                <p class="book-collection-card__author">Ricardo Salinas</p>
                                <h3 class="book-collection-card__title">{t2("2026.libro2")}</h3>
                                <p class="book-collection-card__summary">{t4("2026.desc2")}
                                </p><a class="book-collection-card__link"
                                    href={"/" + i18n.language + "/LibroNegocios"}>{t2("2026.bookmore")}</a>
                            </div>
                        </article>
                        <article class="book-collection-card"><img
                            loading="lazy" class="book-collection-card__image" src={bannerImageBlanco}
                            alt="Portada del libro Ideas sobre la libertad para cambiar al mundo" />
                            <div class="book-collection-card__copy">
                                <p class="book-collection-card__author">Ricardo Salinas</p>
                                <h3 class="book-collection-card__title">{t2("2026.libro4")}</h3>
                                <p class="book-collection-card__summary">{t4("2026.desc4")}
                                </p><a class="book-collection-card__link"
                                    href={"/" + i18n.language + "/LibroLibertad"}>{t2("2026.bookmore")}</a>
                            </div>
                        </article>
                    </div>
                </section>
            </div>
            <div class="_ngcontent-ng-c4013722087 _nghost-ng-c411527492 flotante-comprar">
                        
                        <a target="_blank" class="book-detail-feature__cta"
                            href="https://www.amazon.com.mx/dp/6079900696/ref=redir_mobile_desktop/135-4069732-7734861?_encoding=UTF8&qid=&ref_=tmm_pap_swatch_0&sr=">{t5("header.buy2")}</a>
                    
            </div>
        </article >
            </div >
        </>
    );
};
export default Libroverde2026;